"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entitySelectFilter = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var input_select_1 = require("../components/forms/input-select");
var entity_filter_1 = require("./entity-filter");
var entitySelectFilter = function (args) {
  var context = args.context,
    options = args.options,
    isMulti = args.isMulti;
  var loading = context.loading,
    t = context.t,
    entities = context.entities;
  var pargs = (0, entity_filter_1.entityFilterArgs)(args);
  var value = (0, lodash_1.toArray)(pargs.value);
  return __assign(__assign({}, pargs), {
    value: !isMulti ? (0, lodash_1.first)(value) : value,
    placeholder: pargs.placeholder && t(pargs.placeholder) || t(isMulti ? 'Select one or more Options' : 'Select an Option'),
    render: function (props) {
      return react_1.default.createElement(input_select_1.InputSelect, __assign({
        borderless: true
      }, props, {
        loading: loading,
        isMulti: isMulti,
        options: options
      }));
    }
  });
};
exports.entitySelectFilter = entitySelectFilter;